import axios from 'axios'
import { Notification } from 'element-ui'
const Url = process.env.VUE_APP_BASE_HOST + '/api/'
const config = {
  // 默认地址
  baseURL: Url,
  // 设置超时时间
  timeout: 50000,
  // 跨域时候允许携带凭证
  withCredentials: true
}

class RequestHttp {
  // 定义成员变量并指定类型
  service
  constructor (config) {
    // 实例化axios
    this.service = axios.create(config)

    /**
     * 请求拦截器
     * 客户端发送请求 -> [请求拦截器] -> 服务器
     * token校验(JWT) : 接受服务器返回的token,存储到vuex/pinia/本地储存当中
     */
    this.service.interceptors.request.use(
      // AxiosRequestConfig
      (config) => {
        // const token = sessionStore().token || '';
        const token = localStorage.getItem('token') || ''
        return {
          ...config,
          headers: {
            Authorization: 'Bearer ' + token, // 请求头中携带token信息
            'Content-Type': 'multipart/form-data'
          }
        }
      },
      (error) => {
        // 请求报错
        Promise.reject(error)
      }
    )

    /**
     * 响应拦截器
     * 服务器换返回信息 -> [拦截统一处理] -> 客户端JS获取到信息
     */
    this.service.interceptors.response.use(
      (response) => {
        const { data } = response // 解构
        // 全局错误信息拦截（防止下载文件得时候返回数据流，没有code，直接报错）
        if (data.code > 0) {
          return Promise.reject(data.msg)
        }
        return data.data
      },
      (error) => {
        // const { response } = error
        // if (response) {
        //   if (response.status === 500) {
            Notification({
              title: '提示',
              message: '数据错误'
            })
        //   } else {
        //     Notification({
        //       title: '提示',
        //       message: response.data.message
        //     })
        //   }
        //   return Promise.reject(response.statusText)
        // }
        return Promise.reject(error.message)
      }
    )
  }
  post (url, params) {
    return this.service.post(url, params)
  }
}

// 导出一个实例对象
export default new RequestHttp(config)
